import type { ComponentProps } from "react";
import { Loading01 } from "@untitled-ui/icons-react";
import { cn } from "@/service/classname.ts";

export const SpinningLoadingIcon = ({
  className,
  ...rest
}: ComponentProps<typeof Loading01>) => {
  return <Loading01 {...rest} className={cn(className, "animate-spin")} />;
};
